export const FETCH_SUB_DEPARTMENTS_COMPLETED = 'FETCH_SUB_DEPARTMENTS_COMPLETED';
export const FETCH_SUB_DEPARTMENTS_ERROR = 'FETCH_SUB_DEPARTMENTS_ERROR';
export const FETCH_SUB_DEPARTMENTS_STARTED = 'FETCH_SUB_DEPARTMENTS_STARTED';

export const UPDATE_SUB_DEPARTMENTS_CURRENT_PAGE = 'UPDATE_SUB_DEPARTMENTS_CURRENT_PAGE';
export const UPDATE_SUB_DEPARTMENTS_PAGE_SIZE = 'UPDATE_SUB_DEPARTMENTS_PAGE_SIZE';

export const ADD_SUB_DEPARTMENT_SEARCH = 'ADD_SUB_DEPARTMENT_SEARCH';
export const CLEAR_SUB_DEPARTMENT_SEARCH = 'CLEAR_SUB_DEPARTMENT_SEARCH';

export const CLEAR_SUB_DEPARTMENT_COLUMN_SORT = 'CLEAR_SUB_DEPARTMENT_COLUMN_SORT';
export const UPDATE_SUB_DEPARTMENTS_COLUMN_SORT = 'UPDATE_SUB_DEPARTMENTS_COLUMN_SORT';
